import React from 'react';

interface InputPriceProps {
  value: string;
  onChange: (raw: string) => void;
  placeholder?: string;
  required?: boolean;
  className?: string;
}

const format = (raw: string) =>
  raw.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const InputPrice: React.FC<InputPriceProps> = ({
  value,
  onChange,
  placeholder = 'Ej. 85.000',
  required,
  className,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\./g, '').replace(/\D/g, '');
    onChange(raw);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={value ? format(value) : ''}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      className={className}
    />
  );
};
